const INDIAN_STATES = [
  { value: 37, label: "Andhra Pradesh" },
  { value: 12, label: "Arunachal Pradesh" },
  { value: 18, label: "Assam" },
  { value: 10, label: "Bihar" },
  { value: 22, label: "Chhattisgarh" },
  { value: 30, label: "Goa" },
  { value: 24, label: "Gujarat" },
  { value: 6, label: "Haryana" },
  { value: 2, label: "Himachal Pradesh" },
  { value: 20, label: "Jharkhand" },
  { value: 29, label: "Karnataka" },
  { value: 32, label: "Kerala" },
  { value: 23, label: "Madhya Pradesh" },
  { value: 27, label: "Maharashtra" },
  { value: 14, label: "Manipur" },
  { value: 17, label: "Meghalaya" },
  { value: 15, label: "Mizoram" },
  { value: 13, label: "Nagaland" },
  { value: 21, label: "Odisha" },
  { value: 3, label: "Punjab" },
  { value: 8, label: "Rajasthan" },
  { value: 11, label: "Sikkim" },
  { value: 33, label: "Tamil Nadu" },
  { value: 36, label: "Telangana" },
  { value: 16, label: "Tripura" },
  { value: 9, label: "Uttar Pradesh" },
  { value: 5, label: "Uttarakhand" },
  { value: 19, label: "West Bengal" },

  // Union Territories
  { value: 35, label: "Andaman and Nicobar Islands" },
  { value: 4, label: "Chandigarh" },
  { value: 26, label: "Dadra and Nagar Haveli and Daman and Diu" },
  { value: 7, label: "Delhi" },
  { value: 1, label: "Jammu and Kashmir" },
  { value: 38, label: "Ladakh" },
  { value: 31, label: "Lakshadweep" },
  { value: 34, label: "Puducherry" },
]


export default INDIAN_STATES;